"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var Info_14px_small_1 = require("../../../img/Info_14px_small");
var MetricDown_1 = require("../../../img/MetricDown");
var MetricUp_1 = require("../../../img/MetricUp");
var ModelResultSlice_1 = require("../../../store/slice/ModelResultSlice");
var styles = require("../../../styles/ModelResultStyles");
var ModelResultStyles_1 = require("../../../styles/ModelResultStyles");
var ConfusionMatricesUtils_1 = require("../../../util/ConfusionMatricesUtils");
var NumberUtils_1 = require("../../../util/NumberUtils");
var Utils_1 = require("../../../util/Utils");
var ModelMetrics_1 = require("../type/ModelMetrics");
var TOP_FACTOR_VALUE_WIDTH = 73;
var formatPrediction = function (header, value, tooltip) {
    var getTooltipInfo = function () { return React.createElement("span", null, tooltip); };
    return (React.createElement("div", { className: ModelResultStyles_1.PredictionDetailMetadataStyle },
        React.createElement("span", { className: ModelResultStyles_1.PredictionDetailHeaderStyle },
            header,
            "\u00A0",
            tooltip && (React.createElement(widgets_1.Tooltip, { getContent: getTooltipInfo },
                React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))))),
        React.createElement("br", null),
        React.createElement("span", { className: ModelResultStyles_1.PredictionDetailValueStyle }, value)));
};
var ModelResultPredictionDetail = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), threshold = _a.sessionThreshold, confusionMatricesClassification = _a.confusionMatricesClassification, modelMetrics = _a.modelMetrics, thresholdOptimization = _a.thresholdOptimization, modelType = _a.type, selectedPrediction = _a.selectedPrediction;
    var _b = React.useState(ModelMetrics_1.ThresholdOptimizeCategory.CUSTOM), optimization = _b[0], setOptimization = _b[1];
    React.useEffect(function () {
        setOptimization(thresholdOptimization);
    }, [thresholdOptimization]);
    if (!selectedPrediction) {
        return React.createElement("div", { className: ModelResultStyles_1.PredictionDetailContainerStyle }, Localize_1.Messages.predictionDetailPlaceholder());
    }
    var renderBinomialMetadata = function () {
        if ((0, Utils_1.isBinomialModel)(modelType)) {
            var metadata = selectedPrediction.metadata;
            return (React.createElement(React.Fragment, null,
                formatPrediction(Localize_1.Messages.score(), (0, NumberUtils_1.formatNumericField)({ value: Number(metadata.score) * 100 })),
                formatPrediction(Localize_1.Messages.thresholdText(), (0, NumberUtils_1.formatNumericField)({ value: (threshold !== null && threshold !== void 0 ? threshold : 0) * 100 }))));
        }
        return null;
    };
    var renderRegressionMetadata = function () {
        if ((0, Utils_1.isRegressionModel)(modelType)) {
            var metadata = selectedPrediction.metadata;
            return (React.createElement(React.Fragment, null,
                formatPrediction(Localize_1.Messages.residualText(), metadata.residual, Localize_1.Messages.residualTooltip()),
                formatPrediction(Localize_1.Messages.percentText(), metadata.percent + '%', Localize_1.Messages.percentTooltip())));
        }
        return null;
    };
    var renderMetadata = function () {
        return (React.createElement(React.Fragment, null,
            formatPrediction(Localize_1.Messages.predictedOutcomeText(), selectedPrediction.metadata.predicted, Localize_1.Messages.predictedOutcomeTooltip()),
            formatPrediction(Localize_1.Messages.actualOutcomeText(), selectedPrediction.metadata.actual, Localize_1.Messages.actualOutcomeTooltip()),
            renderBinomialMetadata(),
            renderRegressionMetadata()));
    };
    var onOptimizationChange = function (val) {
        if (!(modelMetrics === null || modelMetrics === void 0 ? void 0 : modelMetrics.validation)) {
            return;
        }
        if ((0, Utils_1.isRegressionModel)(modelType)) {
            return;
        }
        var category = val;
        setOptimization(category);
        dispatch((0, ModelResultSlice_1.setThresholdOptimization)(category));
        var binomialMetricsValidation = modelMetrics.validation;
        var threshold = (0, ConfusionMatricesUtils_1.getDefaultThreshold)(binomialMetricsValidation.confusionMatrices, confusionMatricesClassification, category);
        if (threshold !== null) {
            dispatch((0, ModelResultSlice_1.updateSessionThreshold)(threshold));
        }
    };
    var renderOptimization = function () {
        if ((0, Utils_1.isRegressionModel)(modelType)) {
            return;
        }
        return (React.createElement(widgets_1.SingleSelectDropdown, { label: Localize_1.Messages.thresholdOptimizationTitle(), list: React.createElement(widgets_1.List, { items: Object.values(ModelMetrics_1.ThresholdOptimizeCategory).map(function (n) { return ({ value: n }); }) }), onChange: onOptimizationChange, type: widgets_1.DropdownButtonType.Outline, value: optimization, style: { width: 200 } }));
    };
    var renderTopFactors = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.PredictionDetailHeaderStyle }, Localize_1.Messages.topFactors()),
            React.createElement("table", null,
                React.createElement("tbody", null, selectedPrediction.topFactors.map(function (factor, index) {
                    var _a;
                    var up = factor.value > 0;
                    return (React.createElement("tr", { key: index },
                        React.createElement("td", null, up ? React.createElement(MetricUp_1.MetricUp, null) : React.createElement(MetricDown_1.MetricDown, null)),
                        React.createElement("td", { style: { color: up ? MetricUp_1.MetricUpColor : MetricDown_1.MetricDownColor, width: TOP_FACTOR_VALUE_WIDTH } }, (0, NumberUtils_1.formatNumericField)({ value: factor.value })),
                        React.createElement("td", { className: ModelResultStyles_1.PredictionDetailTopFactorStyle }, (_a = factor.columns) === null || _a === void 0 ? void 0 : _a.map(function (column, index) { return (React.createElement("div", { key: "".concat(column.columnName, "_").concat(index) }, "".concat(column.columnName, ": ").concat(column.columnValue))); }))));
                })))));
    };
    return (React.createElement("div", { className: ModelResultStyles_1.PredictionDetailContainerStyle },
        renderMetadata(),
        renderOptimization(),
        renderTopFactors()));
};
exports.default = ModelResultPredictionDetail;
//# sourceMappingURL=ModelResultPredictionDetail.js.map